import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Hooks/AuthProvider";
import { isGoogleOAuthInProgress } from "../Utils/pendingGoogleOAuth";
import LoadingSpinner from "./LoadingSpinner";

export const ProtectedRoute = ({ children }) => {
  const { user, loading, isCompletingGoogleSignIn } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  const oauthSignInPending =
    isCompletingGoogleSignIn || isGoogleOAuthInProgress();

  if (!user && oauthSignInPending) {
    return <LoadingSpinner />;
  }

  const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
  if (!user && !isOffline) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};
